import Marquee from "react-fast-marquee";

export default function MarqueeStrip() {
  const items = ["PRECISION CRAFT", "PREMIUM FINISH", "HONEST PRICING", "OUTDOEM MAINTENANCE", "INTERIOR PAINTING"];
  return (
    <div className="bg-[#111] py-5 overflow-hidden" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 font-head font-extrabold tracking-tight text-2xl md:text-4xl text-[#F6F6F2] flex items-center gap-8">
            {t}
            <span className="text-[#FF4500]">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
